import React, { useState, useEffect, useCallback } from "react"
import Sidebar from "../../../Components/Sidebar"
import axios from "axios"
import { url } from "../../../Address/BaseUrl"
import { Message } from "../../../Components/Message"
import { Spin, Popconfirm, Tooltip } from "antd"
import Select from "react-select"
import {
	LoadingOutlined,
	CheckCircleOutlined,
	SearchOutlined,
	FileExcelOutlined,
	PrinterOutlined,
} from "@ant-design/icons"
import debounce from "lodash.debounce"
import DynamicTailwindTable from "../../../Components/Reports/DynamicTailwindTable"
import { rejectTransFieldNames, transactionFieldNames, requestedRequisitionHeader } from "../../../Utils/Reports/headerMap"
import Radiobtn from "../../../Components/Radiobtn"
import TDInputTemplateBr from "../../../Components/TDInputTemplateBr"
import { formatDateToYYYYMMDD } from "../../../Utils/formateDate"
import { getLocalStoreTokenDts } from "../../../Components/getLocalforageTokenDts"
import { routePaths } from "../../../Assets/Data/Routes"
import { useNavigate } from "react-router"
import { printTableReport } from "../../../Utils/printTableReport"
import { useCtrlP } from "../../../Hooks/useCtrlP"
import { exportToExcel } from "../../../Utils/exportToExcel"

const RejectRequisition = () => {
	const userDetails = JSON.parse(localStorage.getItem("user_details")) || {}

	const [loading, setLoading] = useState(false)
	const [searchKeywords, setSearchKeywords] = useState("")
	const [data, setData] = useState([])
	const [selectedRowIndices, setSelectedRowIndices] = useState([])
	const [suggestions, setSuggestions] = useState([])
	const [showSuggestions, setShowSuggestions] = useState(false)
	const [searchType, setSearchType] = useState(() => "R")
	const [fromDate, setFromDate] = useState("")
	const [toDate, setToDate] = useState("")
	const [selectedOptions, setSelectedOptions] = useState([])
	const [branches, setBranches] = useState([])
	const [isGroupSelected, setIsGroupSelected] = useState(false)
	const navigate = useNavigate()

	const [md_columns, setColumns] = useState([])
	const [selectedColumns, setSelectedColumns] = useState(null)

	const options2 = [
		{
			label: "Send Requisition to Head Office",
			value: "R",
		},
		{
			label: "Received Granted Requisition",
			value: "S",
		},
	]

	useEffect(() => {
		getBranches()
		if (searchType === "S") {
			search_reject_loan_trans()
		} else {
			setData([])
		}
	}, [searchType])

	const onChange2 = (e) => {
		console.log("radio1 checked", e)
		setSearchType(e)
	}

	const getBranches = async () => {
		setLoading(true)
		const creds = {
			emp_id: userDetails?.emp_id,
			user_type: userDetails?.id,
		}

		const tokenValue = await getLocalStoreTokenDts(navigate)

		axios
			.post(`${url}/fetch_branch_name_based_usertype`, creds, {
				headers: {
					Authorization: `${tokenValue?.token}`,
					"Content-Type": "application/json",
				},
			})
			.then((res) => {
				if (res?.data?.suc === 0) {
					navigate(routePaths.LANDING)
					localStorage.clear()
				} else {
					setBranches(res?.data?.msg)
				}
			})
			.catch((err) => {
				console.log("ERRRR>>>", err)
				setLoading(false)
			})
		setLoading(false)
	}

	useEffect(() => {
		if (data.length > 0) {
			setSelectedRowIndices(data.map((_, idx) => idx))
		} else {
			setSelectedRowIndices([])
		}
	}, [data])

	const fetchGroupNames = async (query) => {
		setLoading(true)
		try {
			const creds = {
				branch_code: userDetails?.brn_code,
				grps: query,
			}

			const tokenValue = await getLocalStoreTokenDts(navigate)

			const res = await axios.post(`${url}/fetch_group_name`, creds, {
				headers: {
					Authorization: `${tokenValue?.token}`,
					"Content-Type": "application/json",
				},
			})

			if (res?.data?.suc === 0) {
				navigate(routePaths.LANDING)
				localStorage.clear()
			} else {
				if (Array.isArray(res?.data?.msg)) {
					setSuggestions(res?.data?.msg)
					setShowSuggestions(true)
				}
			}
		} catch (err) {
			console.error(err)
			setSuggestions([])
			setShowSuggestions(false)
		}
		setLoading(false)
	}

	const dropdownOptions = branches?.map((branch) => ({
		value: branch.branch_assign_id,
		label: `${branch.branch_name} - ${branch.branch_assign_id}`,
	}))

	const displayedOptions =
		selectedOptions.length === dropdownOptions.length
			? [{ value: "all", label: "All" }]
			: selectedOptions

	const handleMultiSelectChange = (selected) => {
		if (selected?.some((option) => option.value === "all")) {
			setSelectedOptions(dropdownOptions)
		} else {
			setSelectedOptions(selected)
		}
	}

	const search_reject_loan_trans = async () => {
		setLoading(true)

		const branchCodes = selectedOptions?.map((item) => ({
			branch_code: item?.value,
		}))

		const creds = {
			branch_code:
				branchCodes?.length === 0
					? [userDetails?.brn_code]
					: branchCodes.map((item) => item.branch_code),
			// req_status: "G",
		}

		// if (fromDate && toDate) {
		// 	creds.from_dt = formatDateToYYYYMMDD(fromDate)
		// 	creds.to_dt = formatDateToYYYYMMDD(toDate)
		// }

		const tokenValue = await getLocalStoreTokenDts(navigate)

		axios
			.post(url + "/search_requested_requisition", creds, {
				headers: {
					Authorization: `${tokenValue?.token}`,
					"Content-Type": "application/json",
				},
			})
			.then((res) => {
				if (res?.data?.suc === 0) {
					navigate(routePaths.LANDING)
					localStorage.clear()
				} else {
					const rawData = res.data?.search_reject_data?.msg || res.data?.data || []
					if (Array.isArray(rawData) && rawData.length > 0) {
						const formattedData = rawData.map((item) => {
							const bId = item.branch_id || item.branch_code || ""
							const gCode = item.group_code || ""
							const bName = item.branch_name ? `${item.branch_name} (${bId})` : `${bId}`
							const gName = item.group_name ? `${item.group_name} (${gCode})` : `${gCode}`
							const cBy = item.created_by || item.requisition_by || ""
							const cAt = item.created_at || item.requisition_at || ""
							const cByAt = cBy ? `${cBy}${cAt ? ` (${cAt})` : ""}` : cAt

							const reqStatus = String(item.requisition_status || "").toUpperCase()
							const statusLabel =
								reqStatus === "G"
									? "Granted From Head Office"
									: reqStatus === "S"
										? "Send to Head Office"
										: reqStatus === "R"
											? "Rejected"
											: item.requisition_status_text || item.requisition_status || ""

							const statusBadge = (
								<span
									className={`px-3 py-1 text-xs font-semibold rounded-full border whitespace-nowrap shadow-sm inline-block ${reqStatus === "G"
										? "bg-green-100 text-green-800 border-green-300 dark:bg-green-900 dark:text-green-200"
										: reqStatus === "S"
											? "bg-blue-100 text-blue-800 border-blue-300 dark:bg-blue-900 dark:text-blue-200"
											: reqStatus === "R"
												? "bg-red-100 text-red-800 border-red-300 dark:bg-red-900 dark:text-red-200"
												: "bg-gray-100 text-gray-800 border-gray-300"
										}`}
								>
									{statusLabel}
								</span>
							)

							const resObj = {
								payment_date: formatDateToYYYYMMDD(item.payment_date || item.transaction_date),
								payment_id: item.payment_id || item.transaction_id,
								branch_name: bName,
								group_name: gName,
								loan_id: item.loan_id,
								debit: Number(item.debit || 0),
								credit: Number(item.credit || 0),
								penal_recov: Number(item.penal_recov || 0),
								requisition_status: statusBadge,
								// requisition_status_text: statusLabel,
								created_by: cByAt,
							}

							if (!(Number(userDetails?.id) === 4 && Number(userDetails?.brn_code) === 100)) {
								delete resObj.branch_name;
							}
							return resObj;
						})
						setData(formattedData)
						populateColumns(formattedData, {
							payment_date: "Payment Date",
							payment_id: "Payment ID",
							branch_name: "Branch Name",
							group_name: "Group Name",
							loan_id: "Loan ID",
							debit: "Debit",
							credit: "Credit",
							penal_recov: "Penal",
							requisition_status: "Requisition Status",
							created_by: "Requisition By & At",
						})
					} else {
						setData([])
						setColumns([])
						setSelectedColumns([])
						Message("warning", res?.data?.msg || "No data found")
					}
				}
				setLoading(false)
			})
			.catch((err) => {
				console.error(err)
				setLoading(false)
			})
	}

	const debouncedFetchGroups = useCallback(
		debounce((nextValue) => {
			fetchGroupNames(nextValue)
		}, 500),
		[]
	)

	const handleSearchChange = (e) => {
		const value = e.target.value
		setSearchKeywords(value)
		setIsGroupSelected(false)
		if (value.length >= 1) {
			debouncedFetchGroups(value)
		} else {
			debouncedFetchGroups.cancel()
			setSuggestions([])
			setShowSuggestions(false)
		}
	}

	const handleSuggestionClick = (grp) => {
		const displayVal = grp?.group_code && grp?.group_name
			? `${grp.group_code} - ${grp.group_name}`
			: String(grp?.group_code || grp?.group_name || "")
		setSearchKeywords(displayVal)
		setIsGroupSelected(true)
		setSuggestions([])
		setShowSuggestions(false)
	}

	const fetchSearchedGroups = async () => {
		setLoading(true)
		const groupCodeVal = String(searchKeywords || "").split(" - ")[0].trim()
		const creds = {
			group_code: groupCodeVal,
			branch_code: userDetails.brn_code,
		}

		const tokenValue = await getLocalStoreTokenDts(navigate)

		try {
			const res = await axios.post(`${url}/fetch_reject_loan_transactions_data`, creds, {
				headers: {
					Authorization: `${tokenValue?.token}`,
					"Content-Type": "application/json",
				},
			})

			if (res?.data?.suc === 0) {
				navigate(routePaths.LANDING)
				localStorage.clear()
			} else {
				const rawData = res?.data?.data || res?.data?.msg || []
				if (Array.isArray(rawData) && rawData.length > 0) {
					const formattedData = rawData.map((item) => {
						const bId = item.branch_id || item.branch_code || ""
						const bName = item.branch_name ? `${item.branch_name} (${bId})` : `${bId}`

						const gCode = item.group_code || ""
						const gName = item.group_name
							? `${item.group_name} (${gCode})`
							: String(gCode)

						const trType = item.tr_type ? String(item.tr_type).toUpperCase() : ""
						const isDebit = trType === "D"
						const isRecovery = trType === "R"

						const cBy = item.created_by || item.requisition_by || ""
						const cAt = item.created_at || item.requisition_at || ""
						const cByAt = cBy ? `${cBy}${cAt ? ` (${cAt})` : ""}` : cAt

						const baseObj = {
							transaction_date: formatDateToYYYYMMDD(item.transaction_date),
							transaction_id: item.transaction_id,
							branch_name: bName,
							group_name: gName,
							loan_id: item.loan_id,
						}

						if (!(Number(userDetails?.id) === 4 && Number(userDetails?.brn_code) === 100)) {
							delete baseObj.branch_name;
						}

						if (isDebit) {
							return {
								...baseObj,
								debit: Number(item.debit || 0),
								created_by: cByAt,
							}
						}

						return {
							...baseObj,
							credit: Number(item.credit || 0),
							penal_recov: Number(item.penal_recov || 0),
							created_by: cByAt,
						}
					})
					setData(formattedData)
					populateColumns(formattedData, transactionFieldNames)
				} else {
					setData([])
					setColumns([])
					setSelectedColumns([])
					Message("warning", res?.data?.msg || "No data found")
				}
			}
		} catch (err) {
			console.error(err)
			Message("error", "Some error occurred while searching...")
		} finally {
			setLoading(false)
		}
	}

	const handleRowSelection = (newSelection) => {
		const isDebitGroup = data.some(
			(item) => String(item.tr_type).toUpperCase() === "D" || Number(item.debit || 0) > 0
		)

		if (isDebitGroup) {
			if (selectedRowIndices.length === data.length) {
				setSelectedRowIndices([])
			} else {
				setSelectedRowIndices(data.map((_, idx) => idx))
			}
		} else {
			setSelectedRowIndices(newSelection)
		}
	}

	const requestRequisition = async () => {
		setLoading(true)

		const isDebitGroup = data.some(
			(item) => String(item.tr_type).toUpperCase() === "D" || Number(item.debit || 0) > 0
		)
		const rowsToProcess = isDebitGroup
			? data.map((_, i) => i)
			: selectedRowIndices

		const checkArr = data
			.filter((_, i) => rowsToProcess.includes(i))
			.map((txn) => ({
				payment_date: txn.transaction_date,
				loan_id: txn.loan_id,
				payment_id: txn.transaction_id,
			}))

		const creds = {
			reject_data: checkArr,
		}

		const tokenValue = await getLocalStoreTokenDts(navigate)

		try {
			// 1. Validation via /check_date_id_before_payment
			const checkRes = await axios.post(`${url}/check_date_id_before_payment`, creds, {
				headers: {
					Authorization: `${tokenValue?.token}`,
					"Content-Type": "application/json",
				},
			})

			if (checkRes?.data?.suc === 0) {
				Message("error", checkRes?.data?.msg || "Validation failed: Cannot request requisition for selected transaction.")
				setLoading(false)
				return
			}

			// 2. Insert requisition data into td_reject_requisition
			const reqDataArr = data
				.filter((_, i) => rowsToProcess.includes(i))
				.map((txn) => {
					const extractedBranchId = txn.branch_name?.match(/\((\d+)\)/)?.[1] || userDetails?.brn_code
					const extractedGroupCode = txn.group_name?.match(/\((\d+)\)/)?.[1] || String(searchKeywords || "").split(" - ")[0].trim()
					return {
						transaction_date: formatDateToYYYYMMDD(txn.transaction_date),
						transaction_id: txn.transaction_id,
						branch_id: extractedBranchId,
						group_code: extractedGroupCode,
						loan_id: txn.loan_id,
						requisition_status: "S",
						requisition_by: userDetails?.emp_id,
					}
				})

			const reqCreds = {
				reject_requisition_data: reqDataArr,
			}

			const saveRes = await axios.post(`${url}/request_reject_requisition`, reqCreds, {
				headers: {
					Authorization: `${tokenValue?.token}`,
					"Content-Type": "application/json",
				},
			})

			if (saveRes?.data?.suc === 0) {
				Message("error", saveRes?.data?.msg || "Failed to submit requisition request.")
			} else {
				Message("success", "Requisition sent successfully.")
				setData([])
				setSelectedRowIndices([])
			}
		} catch (err) {
			Message("error", "Some error occurred.")
			console.log("ERRR", err)
		} finally {
			setLoading(false)
		}
	}

	const dataToExport = data.map((item) => ({
		...item,
		requisition_status: item.requisition_status_text || item.requisition_status,
	}))

	const getColumnTotals = (dt) => {
		if (!dt || !Array.isArray(dt) || dt.length === 0 || !dt[0]) return []
		const keys = Object.keys(dt[0])
		const indices = []
		keys.forEach((key, idx) => {
			if (key === "debit" || key === "credit" || key === "penal_recov") {
				indices.push(idx)
			}
		})
		return indices
	}

	const headersToExport = searchType === "S" ? requestedRequisitionHeader : transactionFieldNames

	const fetchSearchTypeName = (type) => {
		if (type === "S") {
			return "Received Granted Requisition"
		}
		return "Send Requisition to Head Office"
	}

	const fileName = `Loan_${fetchSearchTypeName(searchType)}_${new Date().toLocaleString("en-GB")}.xlsx`

	const handlePrint = useCallback(() => {
		printTableReport(dataToExport, headersToExport, fileName?.split(",")[0], [0, 2])
	}, [dataToExport, headersToExport, fileName])

	useCtrlP(handlePrint)

	const populateColumns = (main_dt, headerExport) => {
		if (!main_dt || !Array.isArray(main_dt) || main_dt.length === 0 || !main_dt[0]) {
			setColumns([])
			setSelectedColumns([])
			return
		}
		const columnToBeShown = Object.keys(main_dt[0]).map((key, index) => ({
			header: headerExport?.[key] || key,
			index,
		}))
		setColumns(columnToBeShown)
		setSelectedColumns(columnToBeShown.map((el) => el.index))
	}

	return (
		<div className="flex">
			<Sidebar mode={2} />
			<div className="flex-1">
				<Spin
					indicator={<LoadingOutlined spin />}
					spinning={loading}
					className="text-slate-800 dark:text-gray-400"
				>
					<main className="px-6 my-8 mx-auto max-w-[1400px]">
						{/* Search Section */}
						<Radiobtn
							data={options2}
							val={searchType}
							onChangeVal={(value) => {
								onChange2(value)
							}}
						/>

						{/* Search Input for Request Requisition (searchType === 'R') */}
						{searchType === "R" && (
							<div className="mt-4">
								<label htmlFor="default-search" className="sr-only">
									Search
								</label>
								<div className="relative mt-10">
									<div className="absolute inset-y-0 start-0 flex items-center ps-3 pointer-events-none">
										<svg
											className="w-4 h-4 text-gray-500 dark:text-gray-400"
											aria-hidden="true"
											xmlns="http://www.w3.org/2000/svg"
											fill="none"
											viewBox="0 0 20 20"
										>
											<path
												stroke="currentColor"
												strokeLinecap="round"
												strokeLinejoin="round"
												strokeWidth="2"
												d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z"
											/>
										</svg>
									</div>
									<input
										type="search"
										id="default-search"
										className="block w-full p-4 ps-10 text-sm text-gray-900 border border-gray-300 rounded-lg bg-gray-50 focus:ring-slate-500 focus:border-slate-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-slate-500 dark:focus:border-slate-500"
										placeholder="Search by Group Code/Group Name"
										value={searchKeywords}
										onChange={handleSearchChange}
									/>
									<button
										type="button"
										className="text-white absolute end-2.5 bottom-2.5 bg-[#DA4167] hover:bg-[#C33157] disabled:bg-[#ee7c98] disabled:cursor-not-allowed font-medium rounded-md text-sm px-4 py-2 focus:ring-4 focus:outline-none focus:ring-blue-300 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
										onClick={fetchSearchedGroups}
										disabled={!String(searchKeywords || "").trim() || (!isGroupSelected && !/^\d+$/.test(String(searchKeywords || "").trim()))}
									>
										Search
									</button>
								</div>
							</div>
						)}



						{/* Group Suggestions Dropdown */}
						{showSuggestions && suggestions?.length > 0 && (
							<ul className="absolute w-96 left-36 right-0 mt-1 z-10 bg-white border border-gray-300 rounded-md shadow-lg max-h-60 overflow-auto">
								{suggestions?.map((grp, idx) => (
									<li
										key={idx}
										className="px-4 py-2 hover:bg-gray-100 cursor-pointer border-b-2"
										onClick={() => handleSuggestionClick(grp)}
									>
										{grp?.group_code} - {grp?.group_name}
									</li>
								))}
							</ul>
						)}

						{/* Title Header & Results Table */}
						<div className="grid grid-cols-2">
							<div className="sm:col-span-2">
								<div className="w-full bg-slate-800 text-slate-50 p-3 pl-5 mt-5 rounded-lg font-bold text-xl">
									{searchType === "S"
										? "Received Granted Requisition"
										: "Send Requisition to Head Office"}
								</div>

								{/* Dynamic Table */}
								<div className="mt-5 p-5 bg-gray-50 rounded-lg shadow-lg">
									<DynamicTailwindTable
										data={data}
										pageSize={50}
										indexing
										dateTimeExceptionCols={[0]}
										showCheckbox={searchType === "R"}
										selectedRowIndices={selectedRowIndices}
										onRowSelectionChange={handleRowSelection}
										headersMap={searchType === "S" ? requestedRequisitionHeader : transactionFieldNames}
										colRemove={[]}
										columnTotal={getColumnTotals(data, searchType)}
									/>

									{searchType === "S" && data.length !== 0 && (
										<div className="flex gap-4">
											<Tooltip title="Export to Excel">
												<button
													onClick={() => {
														let exportedDT = dataToExport.map((item) => ({
															...item,
															payment_id: item.payment_id != null ? `${item.payment_id}` : "",
														}))
														const tot_credit = exportedDT.reduce(
															(sum, cur) => sum + Number(cur.credit || 0),
															0
														)
														const tot_penal = exportedDT.reduce(
															(sum, cur) => sum + Number(cur.penal_recov || 0),
															0
														)
														exportedDT.push({
															payment_date: "TOTAL",
															credit: tot_credit.toFixed(2),
															penal_recov: tot_penal.toFixed(2),
														})
														const dt = md_columns.filter((el) =>
															selectedColumns?.includes(el.index)
														)
														let header_export = {}
														Object.keys(headersToExport || {}).forEach((key) => {
															if (
																dt.filter(
																	(ele) => ele.header === headersToExport[key]
																).length > 0
															) {
																header_export = {
																	...header_export,
																	[key]: headersToExport[key],
																}
															}
														})
														exportToExcel(
															exportedDT,
															header_export,
															fileName,
															[0, 2]
														)
													}}
													className="mt-5 justify-center items-center rounded-full text-green-900"
												>
													<FileExcelOutlined style={{ fontSize: 30 }} />
												</button>
											</Tooltip>

											<Tooltip title="Print">
												<button
													onClick={() => {
														let exportedDT = dataToExport.map((item) => ({
															...item,
															payment_id: item.payment_id != null ? `${item.payment_id}` : "",
														}))
														const tot_credit = exportedDT.reduce(
															(sum, cur) => sum + Number(cur.credit || 0),
															0
														)
														const tot_penal = exportedDT.reduce(
															(sum, cur) => sum + Number(cur.penal_recov || 0),
															0
														)
														exportedDT.push({
															payment_date: "TOTAL",
															credit: tot_credit.toFixed(2),
															penal_recov: tot_penal.toFixed(2),
														})
														const dt = md_columns.filter((el) =>
															selectedColumns?.includes(el.index)
														)
														let header_export = {}
														Object.keys(headersToExport || {}).forEach((key) => {
															if (
																dt.filter(
																	(ele) => ele.header === headersToExport[key]
																).length > 0
															) {
																header_export = {
																	...header_export,
																	[key]: headersToExport[key],
																}
															}
														})
														printTableReport(
															exportedDT,
															header_export,
															fileName?.split(",")[0],
															[0, 2]
														)
													}}
													className="mt-5 justify-center items-center rounded-full text-pink-600"
												>
													<PrinterOutlined style={{ fontSize: 30 }} />
												</button>
											</Tooltip>
										</div>
									)}
								</div>

								{data?.length > 0 &&
									userDetails?.id !== 3 &&
									selectedRowIndices?.length !== 0 &&
									searchType === "R" && (
										<div>
											<Popconfirm
												title="Send Requisition?"
												description="Are you sure you want to send requisition for selected transaction(s)?"
												onConfirm={async () => {
													requestRequisition()
												}}
												onCancel={() => null}
												okText="Yes"
												cancelText="No"
												disabled={selectedRowIndices?.length === 0}
											>
												<button className="items-center -mt-16 px-6 py-3 text-sm font-medium text-center text-white border border-[#DA4167] bg-[#DA4167] transition ease-in-out hover:bg-[#ac3246] hover:border-[#ac3246] duration-300 rounded-full dark:focus:ring-primary-900">
													<CheckCircleOutlined /> <span className="ml-2">Send Requisition</span>
												</button>
											</Popconfirm>
										</div>
									)}
							</div>
						</div>
					</main>
				</Spin>
			</div>
		</div>
	)
}

export default RejectRequisition
